import WbHttpClient from './wbhttpclient';

export default class UserServices {
  constructor() {
    this.WbHttpClient = new WbHttpClient();
  }

  pushEventForUser(params = {}) {
    return this.WbHttpClient.get('workboard/pushEventForUser', params);
  }
  
  getLeftMenuData(params = {}) {
    return this.WbHttpClient.get('workboard/getLeftMenuData', params);
  }
  
  userFavoritesSorting(params = {}) {
    return this.WbHttpClient.post('workboard/userFavoritesSorting', params);
  }

  saveUserPreferenceWs(params = {}) {
    return this.WbHttpClient.post('workboard/saveUserPreferenceWs', params);
  }

  openCloseAllTray(params = {}) {
    return this.WbHttpClient.post('activity/openCloseAllTray', params);
  }

  saveMyWorkCollapse(params = {}) {
    return this.WbHttpClient.post('activity/saveMyWorkCollapse', params);
  }
  
  getTopMenuData(params = {}) {
    return this.WbHttpClient.get('workboard/getTopMenuData', params);
  }

  getWsLeftMenuData(params = {}){
    return this.WbHttpClient.get('board/getWsLeftMenus',params);
  }

  pushUserEvents(params = {}) {
    return this.WbHttpClient.post('workboard/pushUserEvents', params)
  }

  trackNavigation(params = {}) {
    return this.WbHttpClient.post('workboard/pushNavigationEvent', params);
  }
}
